import { render, staticRenderFns } from "./DetailsStep.vue?vue&type=template&id=263859fa&scoped=true&"
import script from "./DetailsStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailsStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailsStep.vue?vue&type=style&index=0&id=263859fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263859fa",
  null
  
)

export default component.exports